import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(section,i){return _c(VSheet,{key:i,staticClass:"mb-2 mx-2 surface",attrs:{"rounded":"lg"}},[_c('flight-strip-section',{staticClass:"surface",attrs:{"title":section.title,"flight-strips":section.flightStrips,"loading":_vm.loading}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }